import { render, staticRenderFns } from "./UpsertWholesalerLogin.vue?vue&type=template&id=86a65734&scoped=true"
import script from "./UpsertWholesalerLogin.vue?vue&type=script&lang=js"
export * from "./UpsertWholesalerLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a65734",
  null
  
)

export default component.exports